import React from 'react';

import { Flex, Line } from 'components';
import { useTranslation } from 'react-i18next';

import { H4 } from 'components/typography';
import { ProductItem } from 'lane-shared/domains/billingPayments/types';
import { type SupportedPaymentCurrency } from 'domains-billing-currency';

import styles from './DraftItemsTable.scss';
import { ItemRow } from '../ItemRow/ItemRow';
import { SupportedLocaleEnum } from 'localization';

export function DraftItemsTable({
  items,
  currency,
  locale,
  addProductButton,
  updateDraftProductItem,
  deleteDraftProductItem,
  channelId,
}: {
  items: ProductItem[];
  currency: SupportedPaymentCurrency;
  locale: SupportedLocaleEnum;
  updateDraftProductItem: (index: number, updatedProduct: ProductItem) => void;
  deleteDraftProductItem: (index: number) => void;
  addProductButton?: React.ReactNode;
  channelId?: string;
}) {
  const { t } = useTranslation();

  return (
    <Flex 
      className={styles.DraftItemsTable} 
      direction="column" 
      gap={5}
      data-test="billing-products-list"
    >
      <H4>{t('abp.productsServices.table.title')}</H4>
      {items.length === 0 ? (
        <ItemRow currency={currency} locale={locale} isDraft />
      ) : (
        items.map((item, index) => (
          <ItemRow
            key={item.id || index}
            item={item}
            currency={currency}
            locale={locale}
            update={(updatedProduct: ProductItem) =>
              updateDraftProductItem(index, updatedProduct)
            }
            remove={() => deleteDraftProductItem(index)}
            isDraft
            channelId={channelId}
          />
        ))
      )}
      <Line className={styles.Divider} />
      {addProductButton}
    </Flex>
  );
}
